import { useFieldValue } from "components/form/input/NestedField";
import TextInput from "components/form/input/TextInput";
import ApontamentoColetas from "entity/Indicador/components/apontamento/fields/ApontamentoColetas";
import ApontamentoCommonFields from "entity/Indicador/components/apontamento/fields/ApontamentoCommonFields";
import ApontamentoImages from "entity/Indicador/components/apontamento/fields/ApontamentoImages";
import ApontamentoClienteParams, {
    ApontamentoParamItem,
} from "entity/Indicador/components/apontamento/fields/ApontamentoClienteParams";
import ApontamentoAmostraParams, {
    useTipoApontamento,
} from "entity/Indicador/components/apontamento/fields/ApontamentoAmostraParams";
import ApontamentoObservacao from "entity/Indicador/components/apontamento/fields/ApontamentoObservacao";
import { useEffect } from "react";
import FormRow from "components/form/FormRow";
import SelectInput from "components/form/input/SelectInput";
import { useCoordinates } from "util/geolocation";
import { Box } from "@mui/material";
import { useForm } from "react-final-form";
import MudaManual from "..";

export default function EditFields({ visita, isNew, TipoClass }) {
    const [tipo] = useTipoApontamento();
    const params = visita.cliente.getParams(MudaManual, tipo, TipoClass);

    const [apontamento] = useFieldValue();
    const form = useForm();
    const [coordinates] = useCoordinates();

    useEffect(() => {
        if (apontamento) {
            apontamento.conformidade = MudaManual.calcConformidade(apontamento, params);
            form.change("despontePerdas", apontamento.despontePerdas);
            form.change("desponteNaoDespontada", apontamento.desponteNaoDespontada);
            form.change("gemasDanificadasFacao", apontamento.gemasDanificadasFacao);
            form.change("gemasDanificadasPragaClima", apontamento.gemasDanificadasPragaClima);

            if (isNew && !apontamento.georeferencia) {
                apontamento.georeferencia = coordinates;
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [apontamento, coordinates, isNew, params]);

    return (
        <>
            <ApontamentoCommonFields visita={visita} showImplemento={false} showVariedade showCorte />

            <ApontamentoAmostraParams>
                <FormRow>
                    <SelectInput name="turno" label="Turno" options={["A", "B", "C"]} />
                </FormRow>
            </ApontamentoAmostraParams>

            <ApontamentoClienteParams params={params}>
                {params ? (
                    <>
                        <FormRow>
                            <ApontamentoParamItem label="D.P.(%):">{params.despontePerdas}</ApontamentoParamItem>
                            <ApontamentoParamItem label="D.N.D.(%):">
                                {params.desponteNaoDespontada}
                            </ApontamentoParamItem>
                            <ApontamentoParamItem label="G.D.F.(%):">
                                {params.gemasDanificadasFacao}
                            </ApontamentoParamItem>
                            <ApontamentoParamItem label="G.D.P.C.(%):">
                                {params.gemasDanificadasPragaClima}
                            </ApontamentoParamItem>
                        </FormRow>
                        <FormRow>
                            <ApontamentoParamItem label="Observação: ">{params.obs}</ApontamentoParamItem>
                        </FormRow>
                    </>
                ) : null}
            </ApontamentoClienteParams>

            <ApontamentoColetas visita={visita} showList={false}>
                <FormRow sx={{ border: 1, borderColor: "grey.400", borderRadius: "16px", p: 2 }}>
                    <Box flexGrow={1} sx={{ ml: 2, display: "flex", alignItems: "center" }}>
                        Despontes (Perdas)
                    </Box>
                    <Box sx={{ display: "flex" }}>
                        <TextInput type="number" name="totalAvaliadoDespontePerdas" label="Avaliado" sx={{ mr: 2 }} />
                        <TextInput type="number" name="totalConformeDespontePerdas" label="Conforme" sx={{ mr: 2 }} />
                        <TextInput type="number" name="despontePerdas" label="%" disabled />
                    </Box>
                </FormRow>
                <FormRow sx={{ border: 1, borderColor: "grey.400", borderRadius: "16px", p: 2 }}>
                    <Box flexGrow={1} sx={{ ml: 2, display: "flex", alignItems: "center" }}>
                        Despontes (Não Despontadas)
                    </Box>
                    <Box sx={{ display: "flex" }}>
                        <TextInput
                            type="number"
                            name="totalAvaliadoDesponteNaoDespontada"
                            label="Avaliado"
                            sx={{ mr: 2 }}
                        />
                        <TextInput
                            type="number"
                            name="totalConformeDesponteNaoDespontada"
                            label="Conforme"
                            sx={{ mr: 2 }}
                        />
                        <TextInput type="number" name="desponteNaoDespontada" label="%" disabled />
                    </Box>
                </FormRow>
                <FormRow sx={{ border: 1, borderColor: "grey.400", borderRadius: "16px", p: 2 }}>
                    <Box flexGrow={1} sx={{ ml: 2, display: "flex", alignItems: "center" }}>
                        Gemas Danificadas (Facão)
                    </Box>
                    <Box sx={{ display: "flex" }}>
                        <TextInput
                            type="number"
                            name="totalAvaliadoGemasDanificadasFacao"
                            label="Avaliado"
                            sx={{ mr: 2 }}
                        />
                        <TextInput
                            type="number"
                            name="totalConformeGemasDanificadasFacao"
                            label="Conforme"
                            sx={{ mr: 2 }}
                        />
                        <TextInput type="number" name="gemasDanificadasFacao" label="%" disabled />
                    </Box>
                </FormRow>
                <FormRow sx={{ border: 1, borderColor: "grey.400", borderRadius: "16px", p: 2 }}>
                    <Box flexGrow={1} sx={{ ml: 2, display: "flex", alignItems: "center" }}>
                        Gemas Danificadas (Praga e Clima)
                    </Box>
                    <Box sx={{ display: "flex" }}>
                        <TextInput
                            type="number"
                            name="totalAvaliadoGemasDanificadasPragaClima"
                            label="Avaliado"
                            sx={{ mr: 2 }}
                        />
                        <TextInput
                            type="number"
                            name="totalConformeGemasDanificadasPragaClima"
                            label="Conforme"
                            sx={{ mr: 2 }}
                        />
                        <TextInput type="number" name="gemasDanificadasPragaClima" label="%" disabled />
                    </Box>
                </FormRow>
            </ApontamentoColetas>

            <ApontamentoObservacao />
            <ApontamentoImages visita={visita} />
        </>
    );
}
